import { render, staticRenderFns } from "./NewProductService.vue?vue&type=template&id=144aa98f&scoped=true"
import script from "./NewProductService.vue?vue&type=script&lang=js"
export * from "./NewProductService.vue?vue&type=script&lang=js"
import style0 from "./NewProductService.vue?vue&type=style&index=0&id=144aa98f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144aa98f",
  null
  
)

export default component.exports